<template>
  <div class="mobile_server">
    <myHeader />

    <!-- banner模块 -->
    <div class="banner">
      <canvas id="canvasId"></canvas>
      <div class="banner_content">
        <p class="banner_content_p" style="font-size:26px">Media Server</p>
        <p style="font-size: 12px; margin-top: 16px" class="banner_content_p1">
          A matching software system for the hecoos multimedia server, which is powerful, stable, and efficient.
        </p>
        <div class="callMe" @click="jumpTo('/en/CaseDemonstration#CallMe')">Contact us</div>
      </div>
    </div>

    <!-- 产品模块 -->
    <div class="product" ref="switch_list">
      <div class="tab" id="tab">
        <p style="font-size: 16px; font-weight: 700" class="tab_p">hecoos Server</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 12px" class="tab_p1">
          What products are included?
        </p>
        <div class="switch">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            Server-D
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-C
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-R
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>

      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <!-- server-D部分 -->
          <div>
            <div class="serverContent" v-show="showContents[0]">
              <div class="text_content">
                <p style="font-size: 14px; margin-bottom: 10px" >Server-D</p>
                <p style="font-size: 26px; margin-bottom: 10px; font-weight: 700">
                  Powerful functionality &nbsp;&nbsp;<span style="color: #2a82e4">
                    Stable and efficien</span>
                </p>
                <p style="
                    font-size: 12px;
                    color: #86868b;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                  ">
                  The hecoos server-D is a matching software for the hecoos system, <span>designed to be powerful, stable, and efficient. </span>
                  Its hardware design meets the strict standards of performance venues and is optimized for quick deployment.
                  Building on traditional stage broadcast control systems, it enables more complex three-dimensional outputs.
                  It also integrates various stage elements—such as video, lighting, and machinery—under unified control and playback.
                  Additionally, it serves as a robust tool for extending LED screen outputs during virtual production. The built-in hecoos software
                  system ensures seamless integration between pre-rehearsal engineering files and on-site execution. By following the hecoos workflow,
                  it allows comprehensive control over all aspects of a performance, from initial concept to final presentation. <span>Through the design
                  philosophy of "Design is Implementation," we aim to help you create exceptional visual experiences.</span>
                </p>
              </div>
              <img style="width: 100%; margin: 20px 0"
                src="https://download.hecoos.com/enlightv/2025-17/9bf5a3c707dd185121045f4da6e76657.png" alt="" />
              <!-- 亮点模块 -->
              <div style="padding: 30px 30px 0">
                <p style="font-size: 14px" class="Key_p">Key features</p>
                <p style="font-size: 26px; font-weight: 700; margin: 10px 0 10px" class="Key_p1">
                  Light up new horizons
                </p>
                <clickSwitch :Info="Info"></clickSwitch>
              </div>

              <!-- 参数部分 -->
              <div class="text_content">
                <p style="font-size: 14px; margin: 30px 0 10px" class="Key_p">
                  Hardware specifications
                </p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 16px">
                  Take a closer look at the specifications
                </p>
                <img style="width: 100%"
                  src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png" alt="" />
              </div>
            </div>
            <div class="parameters" v-show="showContents[0]">
              <div class="parameters_content">
                <p style="font-size: 16px" class="parameters_content_p">Technical specification</p>
                <div class="detailed">
                  <p style="font-size:12px">
                    Operating Voltage: 100-240V, 50-60Hz, 13 amps<br />
                    Operating Power: 800W @ 110V (Normal), 1000W @ 110V (Max)<br />
                    Chassis Specifications: 4U 19” Rack Mount<br />
                    Operating System: Windows 10 Pro<br />
                    CPU Processor: Intel Xeon Gold 6226R Processor (16 Cores, 32
                    Threads)<br />
                    System Memory: 64GB RDIMM DDR4 Memory (32GB x 2)<br />
                    Single System Graphics Memory Requirement: 16GB<br />
                    Single System Supported Texture Pixels: 1920*1080*16<br />
                    Artnet: Supported<br />
                    System Storage: 2TB SSD<br />
                    Maximum Number of SSD Drives: 4<br />
                    Supports Physical Cascading Expansion Mode: No Quantity
                    Limit<br />
                    Supports Optitrack Infrared Tracking System<br />
                    Features: Backplane lighting PCI-E Expansion Connectors<br />
                    Network Interface: 1x GB LAN, 10x GB LAN<br />
                    OLED Status Text Display: (Detailed Description)<br />
                    Chassis Dimensions (mm): Width: 430 Height: 178 Depth: 634
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">
                  Environmental tolerance
                </p>
                <div class="detailed">
                  <p style="font-size:12px">
                    Temperature:5-35°C(40°-95°)<br />
                    Humidity:5%-95%(non-condensing)<br />
                    Altitude:0-8850ft(0-2700m)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">
                  I/O specifications
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Video Output<br />
                        <span style="color: #a6a6a6; font-size: 12px">
                          6 x DisplayPort 1.2<br />
                          Maximum resolution per independent output hannel:
                          (4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Video Input<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution per independent input channel:
                          (4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Data/Peripherals
                        <br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2 <br />Maximum resolution per
                          independent output channel: (4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Audio/Video Input/Output
                        <br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution per independent output channel:
                          (4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px; width: 105px;" class="detailed_box_p">Original accessories</p>
                  <p style="width: 190px;">
                    Mechanical keyboard and mouse<br />
                    800W platinum power supply<br />
                    Circular cable output<br />
                    DP to DVI adapter x6<br />
                    DP cable x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px; width: 105px ;" class="detailed_box_p">After-sales service</p>
                  <p style="width: 190px;">
                    Lifetime free software usage and upgrades<br />
                    Two-year free hardware warranty<br />
                    Remote technical support<br />
                    Server usage and upgrades
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-C部分 -->
          <div>
            <div class="serverContent" v-show="showContents[1]">
              <div class="text_content">
                <p style="font-size: 14px; margin-bottom: 10px">Server-C</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px">
                  Virtual Reality&nbsp;&nbsp;<span style="color: #2a82e4">Precisely fit and match</span>
                </p>
                <p style="
                    font-size: 12px;
                    color: #86868b;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                  ">
                  A multimedia server specially designed for virtual production, the Server-C functions as a core component in virtual production shooting. Known as the <span>"Core Hub,"</span>
                   it collaborates with tracking systems. Using tracking data like actor positions and camera trajectories, it dispatches the real-time rendering engine to
                   dynamically adjust scene perspectives, ensuring seamless integration of virtual and real elements with precise matching. When integrated with lighting
                   systems, it adjusts virtual object lighting in real-time to match the scene's atmosphere, enhancing the final visual impact. The Server-C offers flexible
                    scalability, stability, and rich I/O interfaces, providing robust support for production sites. <span>Additionally, it supports professional customized
                    configurations based on specific on-site requirements, making it essential for virtual production work.</span>
                </p>
              </div>
              <img style="width: 100%; margin: 20px 0"
                src="https://download.hecoos.com/enlightv/2025-17/58ba9ed9b9f7b2f7e2a0b221d3438db8.png" alt="" />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info"></clickSwitch>
              <!-- 参数部分 -->

              <div class="text_content">
                <p style="font-size: 14px; margin: 30px 0 10px">Hardware Specifications</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 16px">
                  Take a close look at the parameters.
                </p>
                <img style="width: 100%"
                  src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png" alt="" />
              </div>
            </div>
            <div class="parameters" v-show="showContents[1]">
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">Technical specification</p>
                <div class="detailed">
                  <p style="font-size:12px">
                    CPU Processor: Intel Xeon Gold 6226R Processor (16 cores, 32 threads)<br />
                    Motherboard: Customized motherboard <br />
                    System memory: 64G RDIMM DDR4 memory (32G x 2)<br />
                    Hard Disk 1: M.2 NVMe SSD 2TB System Disk <br />
                    Hard Disk 2: U.2 NVMe SSD Data Disk 4TB<br />
                    Fan model: Customized cooling fan <br />
                    Case model: Custom case <br />
                    Graphics card: A5000 24GB GDDR6<br />
                    Synchronous Card: NVIDIA 2nd Generation Synchronous Card <br />
                    Card: BMD-8k pro<br />
                    BMC card: Remote Network Management <br />
                    Network card 1: 1Gb RJ45 <br />
                    NIC 2: Mellanox 100Gb<br />
                    Optical port multi-screen card backplate: Customized multi-screen card backplate<br />
                    Multi-screen card motherboard: Customized multi-screen card motherboard DP/DVI
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">
                  Work environment tolerance
                </p>
                <div class="detailed">
                  <p>
                    Temperature: 5 - 35°C (40° - 95°) <br />
                    Humidity: 5% - 95% (non-condensing) <br />
                    Altitude: 0 - 8850 ft (0 - 2700 m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">I/O specification</p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Video output<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Video input<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2 <br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Data/Peripheral Devices<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Audio and video input/output<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px; width: 105px;">Original accessories</p>
                  <p style="width: 190px;">
                    Mechanical keyboard and mouse <br />
                    800W Platinum Power Supply <br />
                    circumferential line<br />
                    DP to DVI adapter cable x6SM <br />
                    DP cable x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px; width: 105px;">After-sales Guarantee</p>
                  <p style="width: 190px;">
                    Software is provided for free for life. <br />
                    Use and upgrade servers <br />
                    Hardware comes with two-year warranty and free service. <br />
                    Remote technical support
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-R部分 -->
          <div>
            <div class="serverContent" v-show="showContents[2]">
              <div class="text_content">
                <p style="font-size: 14px; margin-bottom: 10px">Server-R</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px">
                  Free choice&nbsp;&nbsp;<span style="color: #2a82e4">Flexible allocation / Adjustment</span>
                </p>
                <p style="
                    font-size: 12px;
                    color: #86868b;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                  ">
                  The hecoos server xR-R media server acts as a <span>powerful engine carrier</span>, integrating three-dimensional virtual scenes created by real-time rendering
                   engines like Unreal Engine, Notch, and Unity3D into the production process. Compliant with the <span>SMPTTEST2110</span> Standard and equipped with a 100G
                   transmission bandwidth, it delivers low-latency, high-quality, and realistic visual effects. It offers excellent compatibility across various engines.
                   Creators can freely choose different engines to collaborate on the same scene and flexibly adjust configurations. When handling heavy and complex
                   real-time rendering tasks, multiple xR-R devices can be employed. Working in conjunction with the R rendering node, it easily manages
                   ultra-high-quality image output through cluster rendering, <span>efficiently handling high-load workloads.</span> Additionally, with features like
                   real-time ray tracing and engine reverse control, it provides comprehensive support for virtual content creators.
                </p>
              </div>
              <img style="width: 100%; margin: 20px 0"
                src="https://download.hecoos.com/enlightv/2025-17/93682b68b9c7f106bf40939e1059af7a.png" alt="" />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info"></clickSwitch>

              <!-- 参数部分 -->

              <div class="text_content">
                <p style="font-size: 14px; margin: 30px 0 10px">Hardware Specifications</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 16px">
                  Take a close look at the parameters.
                </p>
                <img style="width: 100%"
                  src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png" alt="" />
              </div>
            </div>
            <div class="parameters" v-show="showContents[2]">
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">Specification Parameters</p>
                <div class="detailed">
                  <p style="font-size:12px">
                    CPU Processor: Intel Core Ultra 9 Processor 285K<br />
                    Motherboard: ASUS Z890 Series motherboard <br />
                    System memory: 64G DDR5 memory <br />
                    Hard Disk 1: M.2 NVMe<br />
                    2T SSD system disk <br />
                    Fan model: Customized cooling fan<br />
                    Case model: General version case<br />
                    System hard disk:2TB SSD <br />
                    Maximum number of SSD hard drives:4<br />
                    Supports physical superior-level cascading expansion mode. The expansion mode is not limited by
                    quantity. Support for Optitrack infrared tracking system.<br />
                    Equipped with back panel lighting <br />
                    Equipped with PCI-E expansion connectors <br />
                    Network interface:1xGB LAN ,10XGB LAN<br />
                    Support for OLED state text display (detailed description)<br />
                    Width and depth of the chassis (mm): 430 (width) * 178 (height) * 634 (depth)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">
                  Work environment tolerance
                </p>
                <div class="detailed">
                  <p>
                    temperature:5-35°C(40°-95°) <br />
                    Humidity:5%-95%(non-condensing) <br />
                    Altitude:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block">I/O specification</p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Video output<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Video input<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2 <br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Data/Peripheral Devices<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        Audio and video input/output<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output channel(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px; width: 105px;">Original factory parts</p>
                  <p style="width: 190px;">
                    Mechanical keyboard and mouse <br />
                    800W Platinum Power Supply <br />
                    circumferential line<br />
                    DP to DVI adapter cable x6SM <br />
                    DP cable x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px; width: 105px;">After-sales Guarantee</p>
                  <p style="width: 190px;">
                    Software is provided for free for life. <br />
                    Use and upgrade servers <br />
                    Hardware comes with two-year warranty and free service. <br />
                    Remote technical support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <myListen :listenList="listenList" v-if="showContents[0]" />
    <myInquire />
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import myListen from "@/components/en_mobile/myListen.vue";
import myInquire from "@/components/en_mobile/myInquire.vue";
import clickSwitch from "@/components/en_mobile/clickSwitch.vue";
import { initThreeNoiseEffect } from '@/utils/threeNoiseEffect.js';
export default {
  data() {
    return {
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      tabInfo: {
        server_D: [
          {
            id: "001",
            title: "Content playback",
            msg: "Powerful non-linear editing rendering engine, real-time high-performance 2D/3D graphics rendering, supporting OpenGL, DirectX, and covering almost all video formats, including more than thirty video codecs such as HAP, HVC, and others, enabling smooth playback of videos, including frame sequences. ",
            url: 'https://download.hecoos.com/enlightv/2025-17/fae918c5d4a93841bc4769f8c4568c8b.png',
          },
          {
            id: "002",
            title: "Screen mapping",
            msg: "HeCoos can directly map video images onto display media through various mapping methods such as parallel projection, spherical projection, perspective projection, and columnar projection according to creative requirements, thus easily achieving 3D Mapping and XR background display.",
            url: 'https://download.hecoos.com/enlightv/2025-17/a6c324978b81ed0e5dc01b3db014ee17.png',
          },
          {
            id: "003",
            title: "Multi-screen display",
            msg: "The video and image decoding capability with infinite resolution, matching the multi-level hierarchical system working architecture of the server, enables smooth point-to-point playback for any resolution and any quantity of LED displays and projectors.",
            url: 'https://download.hecoos.com/enlightv/2025-37/58a8c128d1bacd451c09589dc9273168.png',
          },
          {
            id: "004",
            title: "3DMapping",
            msg: "Support 3D model import. It can align the video to the surface of the model according to the unfolding method of UV. Meanwhile, it can conduct pre-performance and viewing in the three-dimensional space. Based on the principle of UV unfolding or perspective projection of the 3D model, the image content is generated. The content is mapped onto the real model through real-time calculation of projection to complete the output of the picture.",
            url: 'https://download.hecoos.com/enlightv/2025-17/896f2237bace53a89cbaa2bc7804040a.png',
          },
          {
            id: "005",
            title: "Flexible Expansion I/O",
            msg: "By connecting to Arduino kits or directly interfacing with devices such as radars, encoders, controllers, etc., a more diverse input and output environment can be achieved. It can be directly connected to mechanical equipment like servo motors, servos, and stepper motors, providing more options for project implementation.",
            url: 'https://download.hecoos.com/enlightv/2025-17/96115941405a2a888c8e3bde5c6ad839.png',
          },
          {
            id: "006",
            title: "Integration of tracking system access",
            msg: "Data access for tracking systems (VICON, blacktrax, optitrack, sInfo, Mo-sys, Redspy, etc.), sensor integration (Radar, infrared, pressure sensing, kinnect, etc.), and open-source hardware integration (ARDUINO, Raspberry Pi, etc.)",
            url: 'https://download.hecoos.com/enlightv/2025-17/d9fac1b1240180c181999e676c3d6d53.png',
          },
        ],
        server_C: [
          {
            id: "001",
            title: "Lens measurement and positioning",
            msg: "Powerful non-linear editing rendering engine, real-time high-performance 2D/3D graphics rendering, supporting OpenGL and DirectX, supporting format override for almost all video formats currently available, including over thirty types of video encoding (such as HAP, HVC, etc.) that can be played smoothly.",
            url: 'https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png',
          },
          {
            id: "002",
            title: "Delay calibration",
            msg: "HeCoos can directly map video images onto display media through various mapping methods such as parallel projection, spherical projection, perspective projection, and columnar projection according to creative requirements, thus easily achieving 3D Mapping and XR background display.",
            url: 'https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png',
          },
          {
            id: "003",
            title: "Color calibration",
            msg: "The video and image decoding capability with infinite resolution, matching the multi-level hierarchical system working architecture of the server, enables smooth point-to-point playback for any resolution and any quantity of LED displays and projectors.",
            url: 'https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png',
          },
          {
            id: "004",
            title: "Multi-camera switching",
            msg: "Support 3D model import. It can align the video to the surface of the model according to the unfolding method of UV. Meanwhile, it can conduct pre-performance and viewing in the three-dimensional space. Based on the principle of UV unfolding or perspective projection of the three-dimensional model, the image content is generated. The content is mapped onto the real model through real-time calculation of projection to complete the output of the picture.",
            url: 'https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png',
          },
          {
            id: "005",
            title: "Engine level/sequence management",
            msg: "By connecting to Arduino kits or directly interfacing with devices such as radars, encoders, controllers, etc., a more diverse input and output environment can be achieved. It can be directly connected to mechanical equipment like servo motors, servos, and stepper motors, providing more options for project implementation.",
            url: 'https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png',
          },
          {
            id: "006",
            title: "Virtual and Realistic Lighting Co-Operation and Control",
            msg: "Data access for tracking systems (VICON, blacktrax, optitrack, sInfo, Mo-sys, Redspy, etc.), sensor integration (Radar, infrared, pressure sensing, kinnect, etc.), and open-source hardware integration (ARDUINO, Raspberry Pi, etc.)",
            url: 'https://download.hecoos.com/enlightv/2025-17/2f2ac00a4b671a5b47513b91bff11a2b.png',
          },
        ],
        server_R: [
          {
            id: "001",
            title: "Rivermax Cluster Rendering",
            msg: "The internal perspective rendering frame is shared among other rendering nodes in the cluster, avoiding waste of rendering resources of each node. With the reasonable division of labor among multiple nodes, the quality and smoothness of the frame are improved. The SMPTE 2110 synchronization strategy is used to lock the frames for each rendering node, ensuring that the output of Unreal Engine is synchronized with the camera.",
            url: 'https://download.hecoos.com/enlightv/2025-37/db71ad0270366115e54aebeb70ad6013.png',
          },
          {
            id: "002",
            title: "Engine selection",
            msg: "As a powerful engine carrier, hecoos integrates the visual content produced by real-time rendering engines such as Unreal Engine, Notch, Unity 3D, TouchDesigner and Processing into the playback and virtual shooting processes. Creators are not restricted to specific engines and can freely choose content tools to complete their works.",
            url: 'https://download.hecoos.com/enlightv/2025-17/1e162cde5a14bffd1123ac5213c9fc89.png',
          },
          {
            id: "003",
            title: "Reverse control of the engine",
            msg: "During the virtual shooting process, through the settings of the real-time rendering engine of the HeCoos reverse editing system, the details of assets can be flexibly adjusted on the shooting site, making the shooting process smoother.",
            url: 'https://download.hecoos.com/enlightv/2025-17/08d68581ca1058f33b9fe8494e3f5cf0.png',
          },
        ],
      },
      Info: [],

      listenList: [
        {
          msg: "In the past creations, there were often deviations between the conception and the actual presentation, and many ideas were difficult to achieve. The collaboration with hecoos changed this situation. The process of simulation and rehearsal enabled my team to anticipate the effect of the work in advance and adjust and optimize it in time. Many kinds of three-dimensional mapping schemes ensured that the final work presentation was consistent with the expectations, and there was no need to compromise the work standards due to technical limitations anymore. For the creative team, this was a very rare opportunity.",
          author: `Deng Bo  "Flying Radish" CEO&Producer`,
        },
      ],
    };
  },
  created() {
    const section = this.$route.query.section;
    // console.log(section,'section');
    if (section >= 0 && section <= 2) {
      this.selectTab(section);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    initThreeNoiseEffect('canvasId');
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  methods: {
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      // console.log('1111110',index);


      this.currentTabIndex = index;
      this.updateUnderlinePosition();
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      if (index === 1) {
        this.Info = this.tabInfo.server_C;
        // console.log(this.Info);
      } else if (index === 2) {
        this.Info = this.tabInfo.server_R;
        // console.log(this.Info);
      } else {
        this.Info = this.tabInfo.server_D;
        // console.log(this.Info);
      }
      // 将index存储到本地
      // localStorage.setItem("tabIndex", index);
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    jumpTo(url) {
      this.$router.push(url);
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
  beforeMount() {
    this.Info = this.tabInfo.server_D;
    // console.log(this.Info);
  },
  components: {
    myHeader,
    myFooter,
    myListen,
    myInquire,
    clickSwitch,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/en_mobile/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      color: white;
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
     @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
</style>
